import React from "react";
import { PortalLegalPage } from "@/components/legal/PortalLegalPage";

export default function SalarieLegal() {
  return <PortalLegalPage portal="salarie" />;
}
